import request from "@/utils/request";

// 获取申请人员信息
export function testingVehiclePages(params) {
  return request({
    url: "/cloud/testing/vehiclePage",
    method: "post",
    data: params
  });
}

